<template>
    <div>
        <label class="resize-settings__select-label">Resize</label>
        <div
            class="resize-settings__radio-wrapper"
            :class="{ 'resize-settings__radio-wrapper--manual': showManualResizeInputs }"
        >
            <RadioGroup :model-value="resizeType" type="button">
                <Radio :label="ResizeType.Manual" @click="setResizeType(ResizeType.Manual)">Manual</Radio>
                <Radio :label="ResizeType.Off" @click="setResizeType(ResizeType.Off)">Off</Radio>
            </RadioGroup>
            <div v-if="showManualResizeInputs" class="new-size-modal__form">
                <span class="new-size-modal__form-input-wrapper new-size-modal__form-item">
                    <Input
                        type="number"
                        min="1"
                        class="new-size-modal__form-input"
                        :model-value="resizeDimensions?.width"
                        @onChange="onDimensionChange('width', $event.target.value)"
                    >
                        <template #append>px</template>
                    </Input>
                </span>
                <span class="new-size-modal__form-item">x</span>
                <span class="new-size-modal__form-input-wrapper new-size-modal__form-item">
                    <Input
                        type="number"
                        min="1"
                        class="new-size-modal__form-input"
                        :model-value="resizeDimensions?.height"
                        @onChange="onDimensionChange('height', $event.target.value)"
                    >
                        <template #append>px</template>
                    </Input>
                </span>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
import { ResizeType } from "hoxton-shared/utils/templateCover";

export default defineComponent({
    props: {
        resizeType: {
            type: String as PropType<(typeof ResizeType)[keyof typeof ResizeType]>,
            validator(value: (typeof ResizeType)[keyof typeof ResizeType]) {
                return Object.values(ResizeType).includes(value);
            }
        },

        resizeDimensions: {
            type: Object as PropType<{ width: number; height: number }>
        }
    },

    emits: ["dimensionChange", "update:resize-type"],

    data() {
        return {
            manualDimensions: { ...this.resizeDimensions },
            ResizeType
        };
    },
    computed: {
        showManualResizeInputs() {
            return this.resizeType === ResizeType.Manual && this.resizeDimensions;
        }
    },

    methods: {
        onDimensionChange(prop: "width" | "height", val: string) {
            this.manualDimensions = { ...this.manualDimensions, [prop]: +val };
            this.$emit("dimensionChange", this.manualDimensions);
        },
        setResizeType(resizeType: (typeof ResizeType)[keyof typeof ResizeType]) {
            this.$emit("update:resize-type", resizeType);
        }
    }
});
</script>

<style lang="scss">
@use "@style/variables" as *;

.resize-settings__algorithm-description {
    color: $grey5;
    font-size: $font-size-small;
    padding: $spacing-smaller 0 0 0;
}

.resize-settings__radio-wrapper {
    margin: 0 0 $spacing-small;

    &--manual {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .ivu-radio {
        display: none;
    }
}

.resize-settings__select-label {
    display: block;
    font-size: $font-size-base;
    font-weight: bold;
    margin: 0 0 $spacing-smaller;
}
</style>
